import axiosInstance from "./AxiosConfig";

class BannerApi {
  async CreateAppReleaseServer(data) {
    try {
      const response = await axiosInstance.post("/banner/create", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAppReleaseServer() {
    try {
      const response = await axiosInstance.get("/banner/get");
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteAppReleaseServer(id) {
    try {
      const response = await axiosInstance.delete(
        `/banner/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateAppReleaseServer(id, data) {
    try {
      const response = await axiosInstance.put(
        `/banner/update/${id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new BannerApi();
